export const TakesAPI = {};

const SLICE = 'takes';

TakesAPI.update = (data, onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/stream/takes`,
    method:   'PUT',
    data:     data,
    slice:     SLICE,
    action:    'update',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

TakesAPI.list = (data, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/stream/takes`,
    method:    'GET',
    data:      {
      stream_id: data
    },
    slice:     SLICE,
    action:    'list',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};
